const AppTheme = {
    light : {
        textColor: "#000",
        backgroundColor: "#FFF",
        boxShadow: "0px -2px 8px black",
        navColor: "#FFF",
        body: "#FFF"
    },
    dark : {
        textColor: "#FFF",
        backgroundColor: "#000",
        navColor: "#1F1F1F",
        body: "#000",
        modal: "#6E6E6E"
    }
};


export default AppTheme;